<script setup>
import {ref} from "vue";
import notificationEmailLogsService from "@/services/notification-email-logs.service";

const showModal = ref(false);
const id = ref(null);
const log = ref(null);

async function getData() {
    const {data} = await notificationEmailLogsService.getDetails(id.value);

    log.value = data;
}

function open(logId) {
    id.value = logId;
    showModal.value = true;
    getData();
}

function resizeFrame(e) {
    const frame = e.target;
    frame.style.height = frame.contentWindow.document.documentElement.scrollHeight + "px";
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" modal-class="modal-w-xl" title="Log Details" hide-footer>
        <div v-if="log">
            <b>{{log.email_subject}}</b>

            <iframe :srcdoc="log.email_body" class="email-body-frame" @load="resizeFrame"/>
        </div>
    </b-modal>
</template>

<style scoped>
.email-body-frame {
    width: 100%;
    min-height: 500px;
    border: none;
    overflow: hidden;
}
</style>

<style>
.modal-w-xl .modal-dialog {
    margin-top: 5vh;
}
</style>
